import {post} from "../../../helper/request";
import {store} from "../../../helper/store";
import {initSlide} from "../../../redux_actions/maps.state.action";
import {error_manager} from "../../../helper/error_manager";
import {set_file_read_status} from "../../../redux_actions/files.action";

export const updateMetsRisk = (fileId, newMetsRisk, activeMapId, slideId) => {
    return new Promise((resolve, reject) => {
        let formData = new FormData();
        formData.set("file_id", fileId);
        formData.set("new_mets_risk", newMetsRisk);
        post('/api/file/update_mets_risk/', formData).then(response => {
            store.dispatch(initSlide(activeMapId, slideId));
            resolve();
        }).catch((err) => {
            error_manager("Error updating Mets Risk", err);
            reject();
        });
    })
}

export const resetMetsRisk = (caseId, activeMapId, slideId) => {
    return new Promise((resolve, reject) => {
        let formData = new FormData();
        formData.set("case_id", caseId);
        post('/api/file/reset_mets_risk/', formData).then(response => {
            store.dispatch(set_file_read_status(response.files, false));
            store.dispatch(initSlide(activeMapId, slideId));
            resolve();
        }).catch((err) => {
            error_manager("Error resetting Mets Risk", err);
            reject();
        });
    })
}